<mat-dialog-content class="modal-content">
  <div class="relative flex flex-0 flex-col border-b py-4 sm:flex-row sm:items-center sm:justify-between">
    <div class="text-2xl font-extrabold tracking-tight">Imágenes</div>
    <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
      <button *canPermissionsOnly="PERMISSIONS_MATERIAL_IMAGES.CREATE" mat-icon-button color="primary" (click)="openCreateModal()">
        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
      </button>
      <!-- <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
          <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
          <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearchChange($event)"/>
      </mat-form-field> -->
    </div>
  </div>
  <div class="flex flex-auto overflow-hidden flex-col">
    <div class="container mt-0 flex-auto flex-col overflow-x-auto">
      <div class="sticky top-0 z-10 dark:bg-gray-900">
        <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSource" cdkDropList
          #list1="cdkDropList" [cdkDropListData]="dataSource.data" (cdkDropListDropped)="onListDrop($event)" 
          matSort matSortDisableClear multiTemplateDataRows>
        
          <ng-container matColumnDef="nro">
            <th mat-header-cell *matHeaderCellDef>Nro</th>
            <td mat-cell *matCellDef="let element; let i = dataIndex">
              <div class="make-ellipse">{{(i+1)}} </div>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef>Imagen</th>
            <td mat-cell *matCellDef="let element">
              <div class="make-ellipse">
                <img style="width: 100px;" [src]="element.image?.link" alt="element?.image?.name">
              </div>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre (atributo alt)</th>
            <td mat-cell *matCellDef="let element">
              <div class="make-ellipse">{{element.image?.name}} </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="statusId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
            <td mat-cell *matCellDef="let element">
              <mat-slide-toggle class="custom-slide-toggle primary" [checked]="element.statusId == 1"
                  [(ngModel)]="element.statusId" [color]="'success'" matTooltip="{{element.statusId == '1' ? 'Activo': 'Inactivo'}}"
                  [disabled]="!(PERMISSIONS_MATERIAL_IMAGES.UPDATE | hasPermission)"
                  (ngModelChange)="onStatusChange($event, element)">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;"></th>
            <td style="text-align: center;" mat-cell *matCellDef="let element; let i=index">
              <button mat-icon-button color="primary" [matMenuTriggerFor]="menu"
                aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button *ngIf="(PERMISSIONS_MATERIAL_IMAGES.UPDATE | hasPermission) && (isEdit)" mat-menu-item (click)="openEditModal(element)">
                  <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                  <span>Editar Registro</span>
                </button>
                <button *canPermissionsOnly="PERMISSIONS_MATERIAL_IMAGES.DELETE" mat-menu-item (click)="openDeleteDialog(element)">
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                  <span>Eliminar Registro</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row"
            [cdkDragDisabled]="!isEditSort" [ngStyle]="{'cursor': isEditSort ? 'ns-resize' : 'null'}"></tr>
        </table>
        <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">
          Lo sentimos, no hay registros para mostrar.
        </div>
      </div>
    </div>
    <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
      <mat-paginator [length]="dataSource.data.length" [pageSize]="50" [pageSizeOptions]="[100, 200, 300, 400]">
      </mat-paginator>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onClose()" class="justify-end">Cerrar</button>
</mat-dialog-actions>

<!-- Modales -->
<ng-template #addModal>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
  <mat-dialog-content class="modal-content">
      <form #createForm="ngForm">
        <!--  <mat-form-field appearance="fill" class="w-full">
          <mat-label>Nombre</mat-label>
          <input matInput [(ngModel)]="currentCreateImage.name" name="name" oninput="this.value = this.value.toUpperCase()" required>
        </mat-form-field> -->

        <div class="p-4" style="text-align: center;">
          <div class="gallery">
            <div *ngFor="let image of images; let i = index" class="gallery-item">
              <img [src]="image && image.imageUrl" alt="Image" class="gallery-img">
              <button mat-icon-button color="warn" (click)="deleteImage(i)" class="delete-button">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <div class="gallery-item">
              <div class="gallery-upload" (click)="openGalleryImages(data)">
                Agregar
              </div>
            </div>
          </div>
        </div>
      </form>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      <button mat-raised-button color="primary" (click)="createImage()"
          [disabled]="!createForm.valid" class="justify-end">Guardar</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #editModal>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
  <mat-dialog-content class="modal-content">
      <form #editForm="ngForm">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Nombre</mat-label>
          <input matInput [(ngModel)]="currentUpdateImage.name" name="name" oninput="this.value = this.value.toUpperCase()" required>
        </mat-form-field>

        <div class="mt-4" style="text-align: center;">
          <button mat-button color="warn" (click)="fileInput.click()" [disabled]="loadSave">
            <mat-icon>file_upload</mat-icon>
            Seleccione una imagen
          </button>
          <br><br>
          <ul>
            <li>
              <span id="file-label">
                {{ fileName }}
              </span>
            </li>
          </ul>
          <input type="file" name="file" #fileInput (change)="onChange(fileInput.files[0])" style="display:none;"
            accept="image/x-png,image/jpg,image/jpeg" />
          <div class="column " style="display: flex; justify-content: center;">
            <img style="height:200px; width: auto;" [src]="imageUrl" />
          </div>
        </div>
      </form>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      <button mat-raised-button color="primary" (click)="updateImage()"
          [disabled]="!editForm.valid">Guardar</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #deleteDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon
        svgIcon="heroicons_outline:exclamation-triangle"
        class="text-red-500 ml-4 mt-6"
        style="font-size: 32px"
      ></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Confirmar eliminación
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea eliminar el registro?</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">
      Conservar
    </button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Eliminar
    </button>
  </mat-dialog-actions>
</ng-template>